(function(){
  function init(root){
    if(!root || root.dataset.eeAlsReady==='true') return;
    root.dataset.eeAlsReady='true';
    var select=root.querySelector('[data-ee-als-state-select]');
    var go=root.querySelector('[data-ee-als-state-go]');
    function openState(code){
      if(!code) return;
      var target=root.querySelector('#als-state-'+code);
      if(!target) return;
      target.open=true;
      target.scrollIntoView({behavior:'smooth',block:'start'});
      if(history.replaceState){history.replaceState(null,'','#als-state-'+code);}
    }
    if(go && select){go.addEventListener('click',function(){openState(select.value);});}
    if(select){select.addEventListener('change',function(){if(window.matchMedia('(max-width:680px)').matches) openState(select.value);});}
    root.querySelectorAll('[data-ee-als-state-link]').forEach(function(link){
      link.addEventListener('click',function(e){
        var code=link.getAttribute('data-ee-als-state-link');
        var target=root.querySelector('#als-state-'+code);
        if(target){e.preventDefault();openState(code);}
      });
    });
    if(location.hash && location.hash.indexOf('#als-state-')===0){
      var existing=root.querySelector(location.hash);
      if(existing){existing.open=true;setTimeout(function(){existing.scrollIntoView({block:'start'});},80);}
    }
  }
  function boot(){document.querySelectorAll('[data-ee-als-hub]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',boot);
})();
